import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import moment, * as moments from 'moment';
import swal from "sweetalert2";
import Documents from "../Shipments/Documents/Documents.vue";
import axios from "axios";

export default {
  name: "order-shipments",
  components: {
    documents: Documents
  },
  props: {
    hasPermissionToEdit: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => ({})
    },
    tags: {
      type: Object,
      default: () => ({})
    },
    shipment: {
      type: Object,
      default: () => ({})
    },
    shipmentkey: {
      type: String,
      required: true,
      default: () => ""
    },
    shipmentIndex: null,
    status: "",
    order: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loadingButton: false,
    }
  },
  methods: {
    ...mapActions({
      saveShipping: "saveShipping"
    }),

    setDefaultDateDispatch() {
      let inputDate = document.querySelector('#date_shipped');

      if (inputDate) {
        let today = new Date();
        inputDate.value = today.toISOString().substr(0, 10);
      }
    },
    editPermissionErrorAlert() {
      swal({
        title: "Ops!",
        text:
          this.$t("Você não possui permissão para editar pedidos."),
        type: "error",
        closeOnConfirm: false,
        closeOnCancel: false,
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: true
      });
    },
    async onSubmit() {
      var hthis = this;

      if (hthis.status === 'shipped' || hthis.status === 'delivered' || hthis.status === 'canceled' || hthis.status === 'pending') {
        await swal(
          'Ops!',
          'Não poderá ser salvo, devido ao seu status avançado!',
          'warning'
        );

        event.onSubmit(false);

      } else {
        event.preventDefault();
        if (!this.hasPermissionToEdit) {
          this.editPermissionErrorAlert();
          return;
        }

        let form = new FormData(event.target);

        if (!form.get("track_code") || form.get("track_code") === '') {
          const ok = await swal({
            title: 'Deseja continuar?',
            type: 'warning',
            text: 'O status do pedido poderá ser alterado para entrega informada, mas o código de rastreio não foi informado.',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Salvar'
          }).then((ok) => {
            return ok.value;
          });

          if (!ok) {
            return;
          }
        }

        let shipping = this.createShipment(form);

        hthis.loadingButton = true;

        axios({
          method: 'POST',
          url: '/api/orders/shipment',
          data: shipping,
          headers: { "content-type": "application/json" }
        }).then(response => {
          swal(
            'Salvo!',
            'Método de entrega salvo com sucesso!',
            'success'
          );
          hthis.loadingButton = false;
        }, error => {
          hthis.loadingButton = false;
          swal(
            'Erro ao salvar!',
            `Erro ao adicionar método de entrega. Contate o suporte; ${error}`,
            'error'
          );
        });
      }
    },

    /*
    * Get inputs of FormData instance and create object of shipment
    * */
    createShipment(form) {
      let shipping = {
        order: {
          id: this.shipmentkey,
          order_id: this.order.id
        },
        shipments: [
          {
            id: form.get("shipping_id"),
            shipping_company: form.get("shipping_company"),
            shipping_method: form.get("shipping_method"),
            track_code: form.get("track_code"),
            track_url: form.get("track_url"),
            estimate_delivery_date: form.get("estimate_delivery_date"),
            nfe_number: form.get("nfe_number"),
            nfe_key: form.get("nfe_key"),
            nfe_link: form.get("nfe_link"),
            nfe_serie: form.get("nfe_serie"),
            cfops: form.get("cfops"),
            nfe_date: null
          }
        ]
      };

      /*
      * Not send only date or hour to backand, if no API won't update
      */
      if (
        form.get("date_shipped") !== ""
      ) {
        const timeShipped = form.get("time_shipped") !== "" ? form.get("time_shipped") : "00:00";
        shipping.shipments[0].date_shipped = form.get("date_shipped") + " " + timeShipped;
      }

      if (
        form.get("nfe_date") !== ""
      ) {
        const time = form.get("nfe_time") !== "" ? form.get("nfe_time") : "00:00";
        shipping.shipments[0].nfe_date = form.get("nfe_date") + " " + time;
      }

      return shipping;
    },

    /**
     * Remove o ultimo objeto do array de shipments
     */
    cancel(id) {
      this.$store.commit("CANCEL_SHIPMENT_INFO", id);
    },

    parseDate(date, obj = null) {
      let formatDate = "Y-MM-DD";

      return (date)
        ? moment.utc(date).format(formatDate)
        : '';
    },

    parseTime(date) {

      /*var time = moment.duration("03:00:00");
      var datetime = moment(date);
      datetime.subtract(time);
      return datetime
        ? moment.utc(datetime).format("HH:mm")
        : '';*/

      var stillUtc = moment.utc(date).toDate();
      return moment(stillUtc).local().format('HH:mm');
    }
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/Orders/OrderShipments/ordershipments.js